// src/api/plannerViewApi.ts
import axiosInstance from "./axiosInstance"; // Reusing the axiosInstance
import { SubmitPayload } from "../types/plannerViewSubmit";  // Request type
import { SubmitResponse } from "../types/plannerViewSubmit"; // Response type
import { isAxiosError } from "axios";

export const getPlannerPricingError = (error: unknown): string | undefined => {
  if (isAxiosError<{ message?: unknown }>(error) && error.response?.status === 422) {
    const message = error.response.data?.message;
    return typeof message === "string" ? message : undefined;
  }
  return undefined;
};

// POST function to send data to the server
export const submitPlannerView = async (
  data: SubmitPayload[] 
): Promise<SubmitResponse> => {
  try {
    const response = await axiosInstance.post<SubmitResponse>(
      "/api/planner-view", // API endpoint
      data // Body of the POST request
    );
    return response.data; // Return the response from the server
  } catch (error) {
    // Handle error (could be a network issue or API error)
    console.error("Error submitting planner view:", error);
    throw error; // Rethrow error to be handled by calling code
  }
};
